module.exports = __webpack_public_path__ + "static/media/01d.0efd0c06.png";